import { useQuery } from '@tanstack/react-query';
import { MemberBucketListClient, MemberBucketListSummaryDTO } from '../services/apiClient';
import { API_BASE_URL } from '../config/config';
import axiosInstance from '../services/axiosInstance';

const apiClient = new MemberBucketListClient(API_BASE_URL, axiosInstance);

// The logged-in member's own bucket list (already resolved with course name/address/logo/
// location — see GET /member/me/bucket-list on the backend), not-yet-played first.
export const useMyBucketList = () => {
  return useQuery<MemberBucketListSummaryDTO[]>({
    queryKey: ['myBucketList'],
    queryFn: async () => {
      const response = await apiClient.getMyBucketList();
      return response?.data || [];
    },
    staleTime: 5 * 60 * 1000,
  });
};
